// extracted by mini-css-extract-plugin
module.exports = {"gas":"Tx_gas__2Y449","select":"Tx_select__3N328","icon":"Tx_icon__3A46A","hidden":"Tx_hidden__2heIe"};